import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

const OfficeHourPage = lazy(() => import('../../pages/settings/office-hour/OfficeHourPage'))

export default function SettingsRouter() {
    return (
        <Routes>
            {/* Path relativo ao prefixo /configuracoes consumido em PrivateRoutes */}
            <Route path='expediente' element={<OfficeHourPage />} />
        </Routes>
    )
}
